import { CloudwatchWidget } from "../../Components/Cloudwatch/CloudWatch";
import { ExternalWidget } from "../../Components/Cloudwatch/model";
import { CG_OCU_METRICS, CG_OCU_METRICS_DIMENSIONS, MetricDefinitions } from "./constants";

const buildExternalWidgets = (cwMetricsSet: MetricDefinitions, dimensions: string): ExternalWidget[] => {
    return cwMetricsSet.graphs.map((graph: any) => {
        return {
            title: graph.title.replace(/_/g, ' '),
            metrics: graph.paramSets.reduce((acc: any[], param: any) => {
                const metrics: any[] = [];
                if (graph.mathFunctionParams) {
                    graph.mathFunctionParams.forEach((mathFunctionParam) => {
                        metrics.push(mathFunctionParam);
                    });
                }
                param.metricNames.forEach((metricName: string) => {
                    metrics.push({
                        alias: 'm0',
                        namespace: cwMetricsSet.namespace,
                        dimensions: dimensions,
                        metric_name: metricName,
                        statistics: param.stats[0],
                    });
                });
                return [...acc, ...metrics];
            }, []),
        };
    });
};

export const getCgOcuMetrics = (
    awsAccountId: string,
    collectionGroupId: string,
    collectionGroupName: string,
    region: string,
    cwDef: boolean = true
): CloudwatchWidget[] | ExternalWidget[] => {
    const dimensions = `[{"Name":"${CG_OCU_METRICS_DIMENSIONS.AWS_ACCOUNT_ID}","Value":"${awsAccountId}"},` +
        `{"Name":"${CG_OCU_METRICS_DIMENSIONS.COLLECTION_GROUP_ID}","Value":"${collectionGroupId}"},` +
        `{"Name":"${CG_OCU_METRICS_DIMENSIONS.COLLECTION_GROUP_NAME}","Value":"${collectionGroupName}"}]`;
    return buildExternalWidgets(
        CG_OCU_METRICS,
        dimensions
    ).filter((widget: ExternalWidget) => widget.metrics.length > 0);
}
